export const CURRENT_ORIGIN = location.origin;
export const isDevelopment = process.env.NODE_ENV === "development";
export const IMG_API = isDevelopment ? "/api/aliyun" : CURRENT_ORIGIN + "/api/aliyun"; // 后边要加 + /oss/files/


// 当前项目地址
export const currentProjectAddress = process.env.VUE_APP_SUB_ADDRESS

